import React from 'react';
import { Search, Clock, TrendingUp, AlertCircle, CheckCircle } from 'lucide-react';

const SearchHeader = ({ searchQuery, metrics, error }) => {
    return (
        <div className="mb-8">
            {/* Main Header */}
            <div className="flex items-center gap-3 mb-4">
                <div className="p-3 bg-blue-500 shadow-lg rounded-xl">
                    <Search className="w-6 h-6 text-white" />
                </div>
                <div>
                    <h1 className="text-3xl font-bold text-gray-800">
                        Résultats de recherche
                    </h1>
                    <p className="text-gray-600">
                        Recherche pour: <span className="font-semibold text-blue-600">"{searchQuery}"</span>
                    </p>
                </div>
            </div>

            {/* Search Metrics */}
            {metrics && (
                <div className="flex flex-wrap gap-4 p-4 mb-4 bg-white border border-gray-100 shadow-sm rounded-xl">
                    <div className="flex items-center gap-2 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-500" />
                        <span className="text-gray-600">
                            <span className="font-semibold text-gray-800">{metrics.totalResults}</span> résultats trouvés
                        </span>
                    </div>
                    <div className="flex items-center gap-2 text-sm">
                        <TrendingUp className="w-4 h-4 text-purple-500" />
                        <span className="text-gray-600">
                            <span className="font-semibold text-gray-800">{metrics.categories}</span> catégories disponibles
                        </span>
                    </div>
                </div>
            )}

            {/* Error Alert */}
            {error && (
                <div className="flex items-center p-4 mb-4 border rounded-xl bg-amber-50 border-amber-200">
                    <AlertCircle className="w-5 h-5 mr-3 text-amber-600" />
                    <div>
                        <p className="font-medium text-amber-800">Attention</p>
                        <p className="text-sm text-amber-700">{error}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchHeader;